import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import React from 'react';
const FunnelStepsListSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul className="flex flex-col gap-1"><Skeleton className="h-14 w-full" /><Skeleton className="h-14 w-full" /><Skeleton className="h-14 w-full" /><Skeleton className="h-14 w-full" /><Skeleton className="h-14 w-full" /><Skeleton className="h-14 w-full" /><Skeleton className="h-14 w-full" /><Skeleton className="h-14 w-full" /></ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default FunnelStepsListSkeleton;